import { render, staticRenderFns } from "./CheckoutConfirmEmail.vue?vue&type=template&id=3aafad07&scoped=true"
import script from "./CheckoutConfirmEmail.vue?vue&type=script&lang=js"
export * from "./CheckoutConfirmEmail.vue?vue&type=script&lang=js"
import style0 from "./CheckoutConfirmEmail.vue?vue&type=style&index=0&id=3aafad07&prod&scoped=true&lang=css"
import style1 from "./CheckoutConfirmEmail.vue?vue&type=style&index=1&id=3aafad07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aafad07",
  null
  
)

export default component.exports